module.exports = __webpack_public_path__ + "static/media/bg_lightspot.a95edf05.png";